export const treasuryModules = {
  treasury: true,
};

export const governanceModules = {
  governance: true,
};
